export default function createRemoveProductButton() {
    var removeButton = document.createElement("button");
    removeButton.innerHTML = "Eliminar";
    removeButton.classList.add("button-link");
    removeButton.name = "remove-product-button";
    return removeButton;
}
